import { useEffect, useState } from 'react';
import { Button, Container, Group, Stack, Text, Title } from '@mantine/core';

const APP_STORE_URL = 'https://apps.apple.com/ch/app/webkredit-ch/id6743714180';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.webkredit.mobile&hl=en';

const isIOS = (ua: string) => /iPhone|iPad|iPod/i.test(ua);
const isAndroid = (ua: string) => /Android/i.test(ua);

const AppRedirectPage = () => {
  const [redirecting, setRedirecting] = useState(true);

  useEffect(() => {
    const ua = navigator.userAgent;

    if (isIOS(ua)) {
      window.location.href = APP_STORE_URL;
      return;
    }

    if (isAndroid(ua)) {
      window.location.href = PLAY_STORE_URL;
      return;
    }

    setRedirecting(false);
  }, []);

  if (redirecting) {
    return null;
  }

  return (
    <Container size="xs" py="xl">
      <Stack align="center" gap="lg">
        <Title order={2} ta="center">Webkredit.ch App</Title>
        <Text ta="center" c="dimmed">
          Wählen Sie Ihre Plattform, um die App herunterzuladen.
        </Text>
        <Group justify="center">
          <Button component="a" href={APP_STORE_URL} target="_blank" rel="noopener noreferrer" size="md" variant="filled">
            App Store (iOS)
          </Button>
          <Button component="a" href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer" size="md" variant="outline">
            Google Play (Android)
          </Button>
        </Group>
      </Stack>
    </Container>
  );
};

export default AppRedirectPage;
